import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Button } from '@/components/ui/button';

const ColorPickerPopover = ({ 
  id, 
  currentColor, 
  pendingColor, 
  isOpen, 
  isSaving, 
  onOpenChange, 
  onColorChange, 
  onSave 
}) => {
  const displayColor = pendingColor || currentColor || '#39FF14';
  const hasChanges = pendingColor && pendingColor !== (currentColor || '#39FF14');

  return (
    <Popover 
      open={isOpen} 
      onOpenChange={(open) => {
        onOpenChange(open);
        if (open) {
          setTimeout(() => {
            const colorInput = document.getElementById(`color-picker-${id}`);
            if (colorInput) colorInput.click();
          }, 100);
        }
      }}
      modal={true}
    >
      <PopoverTrigger asChild>
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          className="w-8 h-8 rounded cursor-pointer border-2 border-gray-300 hover:border-gray-400"
          style={{ backgroundColor: displayColor }}
          title="Click to change marker color"
        />
      </PopoverTrigger>
      <PopoverContent className="p-2 relative overflow-visible z-[9999]" style={{ width: '236px' }} onClick={(e) => e.stopPropagation()} sideOffset={5}>
        <div className="flex flex-col gap-2">
          <Button
            variant="default"
            size="sm"
            type="button"
            disabled={isSaving || !hasChanges}
            onClick={async (e) => {
              e.stopPropagation();
              if (!hasChanges) return;
              await onSave();
            }}
            className="w-full h-8"
          >
            {isSaving ? (
              <span className="flex items-center justify-center gap-1">
                <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
              </span>
            ) : 'Save'}
          </Button>
          <input
            id={`color-picker-${id}`}
            type="color"
            value={displayColor}
            onChange={(e) => onColorChange(e.target.value)}
            className="absolute opacity-0 pointer-events-auto"
            style={{ bottom: '-13px', left: '-6px', width: '1px', height: '1px' }}
          />
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default ColorPickerPopover;
